import { useEffect } from 'react';

const UserWayWidget = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('data-account', 'NAZUioz51c'); // Substitua pelo seu ID real
    script.src = 'https://cdn.userway.org/widget.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // limpa ao desmontar
    };
  }, []);

  return null;
};

export default UserWayWidget;
